<template>
  <div class="signup-page">
    <div class="container">
      <div class="columns">
        <div class="column is-6 is-offset-3">
          <h1 class="title has-text-centered">Registre-se</h1>
          <signup-form
            :on-submit="SignUp"
            :is-loading="disableSignUpForm"
            :is-disabled="disableSignUpForm"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SignupForm from '../forms/SignupForm'
import { CreateUser } from '../../api/user'
import { prepareFormData } from '../../helpers'

export default {
  name: 'SignupPage',
  components: { SignupForm },
  data () {
    return {
      disableSignUpForm: false
    }
  },
  methods: {
    SignUp (data) {
      this.disableSignUpForm = true
      CreateUser(prepareFormData(data))
        .then(
          success => {
            console.log(success)
            this.disableSignUpForm = false
            this.$modal.open({
              content: 'Conta de usuário criada com sucesso!',
              title: 'Sucesso',
              showCancel: false,
              onOk: () => this.$router.push('/login')
            })
          },
          error => {
            console.log(error.response)
            if (error.response.status === 422) {
              this.$notify.open({
                type: 'danger',
                content: 'O email informado já está em uso',
                duration: 10000
              })
            }
            this.disableSignUpForm = false
          }
        )
    }
  }
}
</script>

<style lang="scss">
.signup-page {
  margin-top: 100px
}
</style>



// WEBPACK FOOTER //
// src/components/pages/SignupPage.vue